import React, { useState } from 'react';
import AddToSelfCart from '../AddToSelfCart/AddToSelfCart';
import './VendorModal.css';

const VendorModal = ({ vendor, onClose, onAddToCart }) => {
  const [showAddToCartModal, setShowAddToCartModal] = useState(false);
  const [selectedMedicine, setSelectedMedicine] = useState(null);

  const handleAddToCartClick = (medicine) => {
    setSelectedMedicine(medicine);
    setShowAddToCartModal(true);
  };

  const handleCloseModal = () => {
    setShowAddToCartModal(false);
    setSelectedMedicine(null);
  };

  return (
    <div className="vendor-modal-overlay" onClick={onClose}>
      <div className="vendor-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-butto" onClick={onClose}>X</button>

        <h2>{vendor.name}</h2>
        <p><strong>Location:</strong> {vendor.location}</p>
        <p><strong>Contact:</strong> {vendor.contact}</p>
        <p><strong>Email:</strong> {vendor.email}</p>
        <p><strong>Opening Hours:</strong> {vendor.openingHours}</p>
        <p><strong>Rating:</strong> {vendor.rating} ⭐</p>
        <p><strong>Services:</strong> {vendor.services.length > 0 ? vendor.services.join(', ') : "None"}</p>
        <p><strong>Website:</strong> <a href={vendor.website} target="_blank" rel="noopener noreferrer">{vendor.website}</a></p>

        {vendor.isUsingSoftware ? (
          <>
            <h2>Available Medicines:</h2>
            <ul className="medicines-list">
              {vendor.availableMedicines.map((medicine, index) => (
                <li key={index} className="medicine-item">
                  <div className="medicine-info">
                    <strong>{medicine.name}</strong> by {medicine.company}
                    <p>Expiry: {medicine.expiryDate}</p>
                    <p>Strength: {medicine.strength}</p>
                    <p>Price: ₹{medicine.price}</p>
                  </div>
                  <button
                    className="add-to-cart-button"
                    onClick={() => handleAddToCartClick(medicine)}
                  >
                    Add to Cart
                  </button>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <div>
            <h2>Contact on WhatsApp:</h2>
            <p>Whatsapp Number: <a href={`https://wa.me/${vendor.whatsappDetails.contact}`} target="_blank" rel="noopener noreferrer">{vendor.whatsappDetails.contact}</a></p>
          </div>
        )}

        {showAddToCartModal && (
          <AddToSelfCart
            medicine={selectedMedicine}
            onClose={handleCloseModal}
            onAddToCart={onAddToCart}
          />
        )}
      </div>
    </div>
  );
};

export default VendorModal;
